import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE, getLanguageFromPath } from '@constants/languages'
import { getItem, setItem, getSessionItem, setSessionItem } from '../utils/storage'

class LanguageService {
  static SUPPORTED_LANGUAGES = SUPPORTED_LANGUAGES
  static DEFAULT_LANGUAGE = DEFAULT_LANGUAGE
  static STORAGE_KEY = 'lang'
  static BANNER_SESSION_KEY = 'lang-banner-session'

  /**
   * Get current language from URL path
   * @returns {string|null} Language code or null if not found
   */
  static getCurrentLanguageFromURL () {
    return getLanguageFromPath(null)
  }

  /**
   * Get stored language preference from localStorage
   * @returns {string|null} Stored language or null
   */
  static getStoredLanguage () {
    const stored = getItem(this.STORAGE_KEY)
    return this.SUPPORTED_LANGUAGES.includes(stored) ? stored : null
  }

  /**
   * Get browser's preferred language
   * @returns {string} Browser language or default
   */
  static getBrowserLanguage () {
    const browserLang = navigator.language || navigator.userLanguage
    const langCode = browserLang.split('-')[0]?.toLowerCase()

    if (this.SUPPORTED_LANGUAGES.includes(langCode)) {
      return langCode
    }
    return this.DEFAULT_LANGUAGE
  }

  /**
   * Save language preference to localStorage
   * @param {string} lang - Language code to save
   */
  static saveLanguage (lang) {
    if (this.SUPPORTED_LANGUAGES.includes(lang)) {
      setItem(this.STORAGE_KEY, lang)
    }
  }

  /**
   * Check if banner was dismissed implicitly this session
   * (User navigated without interacting with banner)
   * @returns {boolean}
   */
  static isBannerDismissedForSession () {
    return getSessionItem(this.BANNER_SESSION_KEY) === 'true'
  }

  /**
   * Mark banner as dismissed for current session only
   * Used when user navigates without explicit interaction
   */
  static dismissBannerForSession () {
    setSessionItem(this.BANNER_SESSION_KEY, 'true')
  }
}

export default LanguageService
